var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { composeFetch, getEnvironmentConfig, setOrigin, } from "../../utility/api";
import { badResponseError } from "../../utility/api/errors";
/**
 * Gets the RestrictedDatesDomain from a fetch response
 *
 * @param environment Pass in a GetArgs type and this will be deconstructed to recieve the environment
 * @returns Returns RestrictedDatesDomain from fetch
 */
export function get(_a) {
    return __awaiter(this, arguments, void 0, function* ({ environment, }) {
        // Not using baseFetch here as this is an assets request that doesn't need anything other than the origin
        const { fetchOrigin } = getEnvironmentConfig(environment);
        const fetcher = composeFetch({ requestModifiers: [setOrigin(fetchOrigin)] });
        const response = yield fetcher(`/assets/json/RestrictedDatesNotForced.json`);
        if (!response.ok)
            throw badResponseError;
        const json = (yield response.json());
        return json;
    });
}
//# sourceMappingURL=index.js.map